import { dropShadow } from '@sleepstation/style-mixins'
import { isRunningInBrowser } from '@sleepstation/utils'
import PropTypes from 'prop-types'
import { complement, includes } from 'ramda'
import React from 'react'
import styled from 'styled-components'
import { ANNOUNCEMENT_BANNER } from '../../../const/banners'
import COOKIE_IDS from '../../../const/cookieIds'
import { findCookieById } from '../../../helpers/cookies'
import BannerBreakoutModule from '../../shared/breakoutModules/BannerBreakoutModule'
import AnnouncementBanner from './AnnouncementBanner'

// -----------------------------------------------------------------------------
// Const
// -----------------------------------------------------------------------------

const { ANNOUNCEMENT } = COOKIE_IDS

// Toggle to force-show banners
const DEBUG = false

// -----------------------------------------------------------------------------
// Utils
// -----------------------------------------------------------------------------

const getIsNotMuted = complement(includes)

// -----------------------------------------------------------------------------
// Sub-components
// -----------------------------------------------------------------------------

const Layout = styled.div`
  ${dropShadow()}
  z-index: 100;
`

// -----------------------------------------------------------------------------
// Component
// -----------------------------------------------------------------------------

const Banners = ({ cookies, domain, banners }) => {
  const announcement = findCookieById(ANNOUNCEMENT, cookies)
  const { isActive: announcementIsActive } = announcement

  const showAnnouncementBanner = getIsNotMuted(ANNOUNCEMENT_BANNER)

  const mutes = banners?.mutes || []

  return (
    <Layout>
      {announcementIsActive &&
        showAnnouncementBanner(mutes) &&
        (DEBUG || isRunningInBrowser()) && (
          <BannerBreakoutModule hasGradient paddingV={1}>
            <AnnouncementBanner
              cookieDefinition={announcement}
              domain={domain}
            />
          </BannerBreakoutModule>
        )}
    </Layout>
  )
}

Banners.propTypes = {
  cookies: PropTypes.arrayOf(PropTypes.object).isRequired,
  domain: PropTypes.string.isRequired,
  banners: PropTypes.object,
}

Banners.defaultProps = {
  banners: {},
}

export default Banners
